import type { NoyauTrial } from '@matter_extractor/shared';

/**
 * The shortcut « Tester l'analyste sur cette relecture » (relecture.md §11), as a
 * pure machine: what the page says of an essay it started, and when the button is
 * closed - and why.
 *
 * The page never shows the six notes of the trial (D4, §11): it says the state of
 * the launch and leads to the parcours, where « Essais de cette session » holds
 * the trial with its source.
 */

export type ReviewTrialState = 'idle' | 'running' | 'rendered' | 'failed';

/**
 * Where the shortcut stands.
 *
 * - `starting` - the request is on its way;
 * - `trial` - the trial as last read, or undefined before any;
 * - `readFailed` - the read of the trial failed: the data kept says pending, of a
 *   trial a restart of the server lost, and it is not running any more.
 */
export function reviewTrialState(input: {
  readonly starting: boolean;
  readonly trial: Pick<NoyauTrial, 'determination'> | undefined;
  readonly readFailed: boolean;
}): ReviewTrialState {
  if (input.starting) return 'running';
  if (input.trial === undefined) return 'idle';
  if (input.readFailed) return 'failed';
  switch (input.trial.determination.state) {
    case 'pending':
      return 'running';
    case 'rendered':
      return 'rendered';
    default:
      return 'failed';
  }
}

/** Why the shortcut is closed, or null when it can be pressed (§11). */
export function reviewTrialWhy(input: {
  readonly extractCount: number;
  readonly trashed: boolean;
}): string | null {
  if (input.trashed) return 'Restaurez la session pour lancer l’analyste.';
  if (input.extractCount === 0)
    return 'Rangez au moins un passage dans une case pour tester l’analyste.';
  return null;
}
